'use client'

import type { PublicationDraft } from '@/lib/publications/types'
import {
  Badge,
  FullBleedImage,
  HandmadeFrame,
  SafeText,
  clampIndex,
  getCopy,
  getDesign,
  getSectorFonts,
  getVisual,
  type HandmadePackProps,
} from '../shared/HandmadePackCore'

const images = ['https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=1200&auto=format&fit=crop','https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=1200&auto=format&fit=crop','https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=1200&auto=format&fit=crop','https://images.unsplash.com/photo-1543269865-cbf427effbad?q=80&w=1200&auto=format&fit=crop']

const fallbackSlides = [{eyebrow:'OPINIÓN',headline:'La mayoría está mirando el problema equivocado',subheadline:'Una postura fuerte que demuestra criterio y experiencia.',cta:'Leer más',bullets:['Idea central', 'Por qué importa', 'Qué cambia']},{eyebrow:'ARGUMENTO',headline:'Esto no es tendencia, es consecuencia',subheadline:'Explica la causa detrás del síntoma con una voz segura.',cta:'Compartir',bullets:['Contexto', 'Contraste', 'Conclusión']},{eyebrow:'CIERRE',headline:'La autoridad se construye con claridad',subheadline:'Una postura simple puede posicionar mejor que mil promesas.',cta:'Hablar conmigo',bullets:['Punto de vista', 'Experiencia', 'Dirección']}]

export default function CreatorAuthorityPack({ draft, activeIndex, onActiveIndexChange }: HandmadePackProps) {
  const total = fallbackSlides.length
  const idx = clampIndex(activeIndex, total)
  const design = getDesign(draft, '#B83A2E')
  const fonts = getSectorFonts('creator')
  const copy = getCopy(draft, idx, fallbackSlides[idx])
  const visual = getVisual(draft, idx, images[idx % images.length], { overlay: 'white', opacity: 0.18, blur: false })

  const accent = design.accent || '#B83A2E'
  const accent2 = design.accentDeep || '#A47C3C'
  const background = '#ECE7DB'
  const surface = '#F7F1E6'
  const text = '#111111'
  const muted = 'rgba(17,17,17,0.58)'
  const border = 'rgba(17,17,17,0.14)'

  return (
    <HandmadeFrame activeIndex={idx} total={total} onActiveIndexChange={onActiveIndexChange} text={text}>

      <div className="absolute inset-0" style={{ background }} />
      <div className="absolute left-0 top-0 h-full w-[18%]" style={{ background: accent, opacity: idx === 0 ? 1 : 0.18 }} />
      {idx === 0 ? <FullBleedImage {...visual} /> : null}
      {idx === 0 ? <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, rgba(236,231,219,0.96) 0%, rgba(236,231,219,0.82) 48%, rgba(236,231,219,0.05) 100%)' }} /> : null}
      <div className="absolute inset-0 p-9">
        <div className="flex h-full flex-col justify-between">
          <div className="flex items-center justify-between"><Badge color={text} background="rgba(0,0,0,0.08)">{copy.eyebrow}</Badge><span className="text-[11px] font-bold uppercase tracking-[0.24em]" style={{ color: muted, fontFamily: fonts.label }}>Editorial</span></div>
          <div className="max-w-[78%]">
            <SafeText className="text-[clamp(36px,9vw,68px)] leading-[0.88] tracking-[-0.055em]" style={{ color: text, fontFamily: fonts.heading }}>{copy.headline}</SafeText>
            <div className="mt-5 h-[2px] w-24" style={{ background: accent }} />
            <SafeText className="mt-5 max-w-[420px] text-[18px] leading-[1.35]" style={{ color: muted, fontFamily: fonts.body }}>{copy.subheadline}</SafeText>
          </div>
          <div className="grid max-w-[82%] grid-cols-3 gap-3">{copy.bullets.slice(0,3).map((item: string, i: number) => <div key={i} className="border-t pt-3 text-[12px] font-bold uppercase tracking-[0.12em]" style={{ borderColor: 'rgba(0,0,0,0.16)', color: text, fontFamily: fonts.label }}>{item}</div>)}</div>
        </div>
      </div>

    </HandmadeFrame>
  )
}
